import {
  applicationCompleted,
  applicationWorkedByApplicant
} from '@features/applications/utils/application-status.ts';
import { identityFailed } from '@features/applications/utils/identity-status.ts';
import { APPLICATION_END_STATUS } from '@features/wizard/end.constants.ts';

import { Application } from '@/types/api.ts';

const isCompletedEndType = ({ status }: Application) => {
  return applicationCompleted(status);
};

const isInReviewEndType = ({ status }: Application) => {
  return !applicationCompleted(status) && !applicationWorkedByApplicant(status);
};

const isIdentityFailureEndType = (application: Application) => {
  const { status } = application.identity;

  return identityFailed(status);
};

const isCreditCheckDeclinedEndType = (application: Application) => {
  return application.credit.status === 'declined';
};

export const getApplicationEndType = (application: Application) => {
  const endTypeChecks = {
    [APPLICATION_END_STATUS.IDENTITY_FAILED]: isIdentityFailureEndType,
    [APPLICATION_END_STATUS.CREDIT_CHECK_DECLINED]: isCreditCheckDeclinedEndType,
    [APPLICATION_END_STATUS.COMPLETED]: isCompletedEndType,
    [APPLICATION_END_STATUS.IN_REVIEW]: isInReviewEndType,
    [APPLICATION_END_STATUS.UNKNOWN]: () => true
  };

  const endType = Object.entries(endTypeChecks)
    .find(([_, check]) => check(application));

  return endType ? endType[0] : APPLICATION_END_STATUS.UNKNOWN;
};
